<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-content">
        <div class="products-item" v-for="item in productsList" :key="item.title">
          <p class="title">{{ item.title }}</p>
          <div class="product-list">
            <div
              class="item"
              v-for="productItem in item.list"
              :key="productItem.name"
              @click="
                linkToProductInfo(
                  productItem.userFuncType
                    ? productItem.userFuncType
                    : productItem.linkurl,
                  productItem.userFuncType ? 'type' : 'url'
                )
              "
            >
              <img :src="productItem.img" alt />
              <div class="info">
                <p class="title">{{ productItem.name }}</p>
                <p class="desc">{{ productItem.content }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState({
      productsList: (state) => state.productsList,
    }),
  },
  mounted() {},
  methods: {
    linkToProductInfo(url, type) {
      if (type == "url") {
        window.open(url);
      } else {
        this.$router.push({
          path: "/marketing/order",
          query: {
            userFuncType: url,
          },
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .list {
    width: 100%;
    padding: 0 20px;
  }
  .tab-content {
    display: block;
    .products-item {
      margin: 27px 0 3px 20px;
      & > .title {
        font-size: 12px;
        line-height: 12px;
        color: #333333;
        font-weight: bold;
        margin-bottom: 17px;
      }
      .product-list {
        display: flex;
        .item {
          background: #f8f8f8;
          display: flex;
          width: 260px;
          height: 74px;
          border-radius: 2px;
          align-items: center;
          margin-right: 20px;
          cursor: pointer;
          transition: all 0.5s;
          &:hover {
            transform: translateY(-10px);
            box-shadow: 5px 5px 5px #eee;
          }
          & > img {
            width: 44px;
            height: 44px;
            margin: 0 10px 0 20px;
            object-fit: contain;
          }
          .info {
            & > p {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              width: 180px;
            }
            .title {
              font-size: 14px;
              line-height: 14px;
              color: #333333;
              margin-bottom: 12px;
              font-weight: bold;
            }
            .desc {
              font-size: 12px;
              line-height: 12px;
              color: #999999;
            }
          }
        }
      }
    }
  }
}
</style>
